export const state = () => ({
  user: process.browser ? JSON.parse(localStorage.getItem('user')) || null : null,
});

export const mutations = {
  setUser(state, user) {
    state.user = user; // Sets the user data
  },
  clearUser(state) {
    state.user = null; // Clears the user data
  },
};

export const actions = {
  setUserInStore({ commit }, user) {
    commit('setUser', user);
    // Save user data to localStorage
    localStorage.setItem('user', JSON.stringify(user));
  },
  clearUserFromStore({ commit }) {
    commit('clearUser');
    // Remove user data from localStorage
    localStorage.removeItem('user');
  },
};

export const getters = {
  isAuthenticated(state) {
    return !!state.user; // Returns true if user is logged in
  },
  user(state) {
    return state.user; // Returns user data
  },
};
